<template>
  <div>
    <!-- <van-popup v-model="show">
      <div class="pay-container">
        <div class="type-img">
          <img src="@/assets/gou.png" alt="" v-if="type === 'success'" />
          <img src="@/assets/cha.png" alt="" v-else />
        </div>
        <div v-if="type === 'success'" class="success-text">
          <p>{{ $t("payType.success") }}</p>
          <h2>{{ money }}AED</h2>
        </div>
        <div v-else class="err-text">
          <h2>{{ $t("payType.fail") }}</h2>
        </div>
        <button v-if="type === 'success'" class="btn btn3" @click="unShow">{{ $t("payType.ok") }}</button>
        <div v-else class="btn btn2">
          <button @click="unShow">{{ $t("payType.back") }}</button>
        </div>
      </div>
    </van-popup> -->
    <el-dialog
      :lock-scroll="true"
      :visible.sync="show"
      width="25%"
      @close="unShow"
    >
      <div class="pay-container">
        <div class="type-img">
          <img src="@/assets/gou.png" alt="" v-if="type === 'success'" />
          <img src="@/assets/cha.png" alt="" v-else />
        </div>
        <div v-if="type === 'success'" class="success-text">
          <p>{{ $t('payType.success') }}</p>
          <h2>{{ money }}AED</h2>
        </div>
        <div v-else class="err-text">
          <h2>{{ $t('payType.fail') }}</h2>
        </div>
        <button v-if="type === 'success'" class="btn btn3" @click="unShow">
          {{ $t('payType.ok') }}
        </button>
        <div v-else class="btn btn2">
          <button @click="unShow">{{ $t('payType.back') }}</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import PayType from "@/mixin/home/PayType.js"
import i18n from '@/lang';
export default {
  data() {
    return {
      show: false,
      type: 'success',
      money: 'null',
    };
  },
  methods: {
    unShow() {
      this.show = false;
      if (i18n.locale === 'english') {
        this.$router.push('/english/home');
      } else {
        this.$router.push('/chinese/home');
      }
    },
  },
  created() {
    let href = new URL(window.location.href);
    if (href.searchParams.get('payStatus')) {
      this.type = href.searchParams.get('payStatus');
      this.show = true;
      this.money = Number(href.searchParams.get('amount')).toFixed(2) || 0;
    }
  },
};
</script>

<style lang="less" scoped>
.pay-container {
  height: 350px;
  width: 100%;
  position: relative;
  overflow: hidden;
  .type-img {
    padding-top: 26px;
    margin: 0 auto;
    width: 70px;
    img {
      width: 100%;
    }
  }
  .success-text {
    p {
      text-align: center;
      margin: 34px 0 24px 0;
      font-family: ArialMT;
      font-size: 24px;
      color: #333333;
    }
    h2 {
      font-size: 50px;
      color: #252525;
      text-align: center;
      font-weight: bold;
      font-family: Arial-BoldMT;
      margin: 20px 0;
    }
  }
  .err-text {
    text-align: center;
    h2 {
      font-family: Arial;
      font-size: 48px;
      color: #333333;
      font-weight: bold;
      margin: 60px 0 26px 0;
    }
    p {
      font-family: Arial;
      font-size: 24px;
      line-height: 27px;
      color: #666666;
    }
  }
}
.btn {
  height: 70px;
  line-height: 70px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}
.btn:hover {
  background-color: #ffda69;
}
button {
  background-color: transparent;
  border: none;
  outline: none;
}
.btn2 {
  display: flex;
  & > button {
    flex: 1;
    display: block;
  }
  & > button:nth-child(1) {
    background-color: #020b3b;
    font-family: Arial-BoldMT;
    font-size: 36px;
    color: #ffcc69;
    cursor: pointer;
  }
  & > button:nth-child(1):hover {
    background-color: #05125e;
  }
  & > button:nth-child(2) {
    background-color: #ffcc69;
    font-family: Arial-BoldMT;
    font-size: 36px;
    color: #020b3b;
  }
}

.btn3 {
  background-color: #ffcc69;
  font-family: Arial-BoldMT;
  font-size: 36px;
  color: #020b3b;
  display: block;
  width: 100%;
}
</style>
